import { useSelector } from 'react-redux';
import { getUserLoggedInStatus } from '../ducks/selectors';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

const defaultProps = {
  readyFlag: false
};

const useLoggedInGuard = ({ readyFlag } = defaultProps) => {
  const isLoggedIn = useSelector(getUserLoggedInStatus);
  const history = useHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!readyFlag) return;
    if (pathname === '/account') {
      return;
    }
    if (!isLoggedIn) {
      history.replace('/account');
    }
  }, [isLoggedIn, readyFlag, pathname]);
};

export default useLoggedInGuard;
